import type { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { FeatureFlagsOptions } from '@/hooks/useFeatureFlags/types';

export const ChannelManagerGate = ({ children }: { children: ReactElement }) => {
  const { featureFlags, loading } = useFeatureFlags();
  if (loading) return null;
  // Sem override de localhost: a flag controla de verdade (off => some em todo lugar).
  const enabled = featureFlags[FeatureFlagsOptions.FF_CHANNEL_MANAGER_ENABLED];
  if (!enabled) {
    return <Navigate to="/home" replace />;
  }
  return children;
};
